import { q } from '../../shared/dom';
import { t } from '../../shared/i18n';
import { money } from '../../shared/format';
import { eventPrizes } from '../../shared/store/selectors';
import { currentEvent } from '../../shared/session/session';
import { live } from './live';

/** Console do operador: barra ancorada no rodapé que sempre diz o próximo passo e a tecla. */
export const consoleTemplate = (): string => `
<div class="console" id="console">
  <div class="c-ctx">
    <div class="c-step" id="c-step">—</div>
    <div class="c-prize" id="c-prizeName">—</div>
  </div>
  <button class="c-main" id="c-next"><span id="c-mainLabel">Sortear</span><span class="c-key">espacio</span></button>
  <div class="c-tools">
    <button id="c-wheel" class="hot" title="Girar la rueda (W)">🎡 <span data-i18n="ctrl.wheel2">Girar la rueda</span> <span class="c-key">W</span></button>
    <button id="c-skip" title="Siguiente premio">⏭ <span data-i18n="ctrl.skip">Siguiente premio</span></button>
    <button id="c-mute" title="Sonido">🔊</button>
    <button id="c-full" title="Pantalla completa">⛶</button>
    <button id="c-hide" title="Ocultar controles (H)">👁 <span data-i18n="ctrl.hide">Ocultar</span> <span class="c-key">H</span></button>
    <button id="c-exit" class="danger" title="Salir (Esc)">✕ <span data-i18n="ctrl.exit">Salir</span> <span class="c-key">esc</span></button>
  </div>
</div>
<button id="console-tab">⌃ <span data-i18n="ctrl.show">Controles</span> <span class="c-key">H</span></button>`;

export function updateConsole(): void {
  const ev   = currentEvent();
  const all  = ev ? eventPrizes(ev.id) : [];
  const pend = all.filter(p => p.status === 'pending');
  const done = all.length - pend.length;
  let step = '', prize = '—', label = t('ctrl.start'), enabled = pend.length > 0;

  if (live.phase === 'idle') {
    step  = `${t('ctrl.prize')} ${Math.min(done + 1, all.length)} / ${all.length}`;
    const next = pend[0];
    prize = next ? next.emoji + '  ' + next.name + '   ·   ' + money(next.value) : t('live.done');
  } else if (live.phase === 'wheel') {
    step = t('ctrl.spinning'); prize = t('ctrl.wheelctx'); enabled = false;
  } else if (live.phase === 'draw' && live.prize) {
    step  = `${t('live.digit')} ${Math.min(live.step + 1, live.digits)} / ${live.digits}`;
    prize = live.prize.emoji + '  ' + live.prize.name;
    label = t('live.reveal'); enabled = !live.busy;
  } else if (live.phase === 'winner' && live.prize) {
    step  = t('stage.winner');
    prize = live.prize.emoji + '  ' + live.prize.name;
    label = t('live.confirm');
    enabled = !live.revealing && !live.busy;
  }
  q('#c-step').textContent      = step;
  q('#c-prizeName').textContent = prize;
  q('#c-mainLabel').textContent = label;
  q<HTMLButtonElement>('#c-next').disabled = !enabled;
}

export function toggleConsole(force?: boolean): void {
  const c = q('#console'), tab = q('#console-tab');
  const off = force === undefined ? !c.classList.contains('off') : force;
  c.classList.toggle('off', off);
  tab.classList.toggle('on', off);
}
